<template>
  <div class="home">

    <transition name="fade" mode="out-in">
      <div class="calculator" v-if="calculated == false" key="calcA">

        <div class="mod-btns">
          <h1>Try Our Presets!</h1>
          <button class="button orange" id="submitTop" v-on:click.prevent="doCalc"><span>Calculate Gravitational Wave Strain</span></button>

          <router-link to="/?do=m87" class="mobile-only">
            <span class="gold">M87</span>
          </router-link>
          <router-link to="/?do=3c66b" class="mobile-only">
            <span class="gold">3C 66B</span>
          </router-link>
          <router-link to="/" class="reset">
            <span class="gold">Reset</span>
          </router-link>



        </div><!-- .mod-btns -->
        <h1 v-html="calculatorTitle"></h1>



        <div class="fieldset">
          <h2 class="legend">Mass</h2>

          <p class="intro"><strong>Enter at least two measurements and use scientific notation.</strong> The letter e is used to mean "10 to the power of." For example, 1.316e5 means 1.316 &times; 10<sup>5</sup> which is 131600.</p>

          <div class="input-wrap">
            <label for="m1">M<sub>1</sub></label>
            <input type="text" id="m1" name="m1" v-model="m1" placeholder="1e9" pattern="[+\-]?(?:0|[1-9]\d*)(?:\.\d*)?(?:[eE][+\-]?\d+)?" v-on:keyup="updateM1($event.target.value)" v-on:blur="updateM1($event.target.value,true)"> M<sub>&#9737;</sub>
          </div><!-- .input-wrap -->

          <div class="input-wrap">
            <label for="m2">M<sub>2</sub></label>
            <input type="text" id="m2" name="m2" v-model="m2" placeholder="1e9" pattern="[+\-]?(?:0|[1-9]\d*)(?:\.\d*)?(?:[eE][+\-]?\d+)?" v-on:keyup="updateM2($event.target.value)" v-on:blur="updateM2($event.target.value,true)"> M<sub>&#9737;</sub>
          </div><!-- .input-wrap -->

          <div class="input-wrap">
            <label for="m_ratio">Ratio (q)</label>
            <input type="number" id="m_ratio" name="m_ratio" v-model="m_ratio" placeholder="1" min="0" max="1" step="0.0001" v-on:keyup="updateR($event.target.value)" v-on:blur="updateR($event.target.value,true)">
          </div><!-- .input-wrap -->

          <div class="input-wrap">
            <label for="total_m">Total Mass</label>
            <input type="text" id="total_m" name="total_m" v-model="total_m" placeholder="2e9" pattern="[+\-]?(?:0|[1-9]\d*)(?:\.\d*)?(?:[eE][+\-]?\d+)?" v-on:keyup="updateTM($event.target.value)" v-on:blur="updateTM($event.target.value,true)"> M<sub>&#9737;</sub>
          </div><!-- .input-wrap -->
        </div>

        <div class="fieldset">
          <h2 class="legend">Distance or Redshift</h2>
            <div class="input-wrap">
              <label for="distance">Distance</label>
              <input type="number" id="distance" name="distance" placeholder="100.00" step="0.01" v-model="distance" :readonly="!watchers_on && !tryme"> Mpc
            </div><!-- .input-wrap -->

            <div class="input-wrap">
              <label for="redshift">Redshift (z)*</label>
              <input type="number" id="redshift" name="redshift" step="0.0001" placeholder="0.0237" min="0" max="10" v-model="redshift" :readonly="!watchers_on && !tryme"> z (years)
            </div><!-- .input-wrap -->

          <p class="small_note">*Assuming a Hubble constant of 70 km s<sup>-1</sup> Mpc<sup>-1</sup></p>
        </div>

        <div class="fieldset">
          <h2 class="legend">Position</h2>

            <div class="full-width center">

            </div><!-- .full-width -->

            <div class="input-wrap">
              <label for="position_ra">Right Ascension</label>

              <div v-show="raOptions == 'decimal'">
                <input type="number" id="position_ra" v-model="position_ra" name="position_ra" placeholder="20.24" step="0.00000001"> h
              </div>


              <div class="thirds" v-show="raOptions == 'hours'">
                <div class="third-box">
                  <input type="number" name="ra_hrs" v-model="ra_hrs" placeholder="20" step="1" min="0">
                  <span>h</span>
                </div><!-- .declination-degrees-box -->
                <div class="third-box">
                  <input type="number" name="ra_min" v-model="ra_min" placeholder="14" step="1" min="0" max="60">
                  <span>m</span>
                </div><!-- .declination-degrees-box -->
                <div class="third-box">
                  <input type="number" name="ra_sec" v-model="ra_sec" placeholder="40.00" step="0.0001" min="0" max="60">
                  <span>s</span>
                </div><!-- .declination-degrees-box -->
              </div><!-- .declination-degrees -->

              <div class="option-btns-contain">
                <label>
                  <input type="radio" name="raOptions" value="decimal" v-model="raOptions" checked>
                  <span>Decimal Hrs</span>
                </label>
                <label>
                  <input type="radio" name="raOptions" value="hours" v-model="raOptions">
                  <span>Hr/Min/Sec</span>
                </label>
              </div><!-- .option-btns-contain -->
            </div><!-- .input-wrap -->

            <div class="input-wrap">
              <label for="position_dec">Declination</label>

              <div v-show="declinationOptions == 'decimal'">
                <input type="number" id="position_dec" v-model="position_dec" name="position_dec" placeholder="80.00" step="0.00000001" min="-90" max="90"> &deg;
              </div>


              <div class="thirds" v-show="declinationOptions == 'degrees'">
                <div class="third-box">
                  <input type="number" name="dec_deg" v-model="dec_deg" placeholder="80" step="1" min="-90" max="90">
                  <span>&deg;</span>
                </div><!-- .declination-degrees-box -->
                <div class="third-box">
                  <input type="number" name="dec_min" v-model="dec_min" placeholder="0" step="1" min="0" max="60">
                  <span>'</span>
                </div><!-- .declination-degrees-box -->
                <div class="third-box">
                  <input type="number" name="dec_sec" v-model="dec_sec" placeholder="0.00" step="0.0001" min="0" max="60">
                  <span>"</span>
                </div><!-- .declination-degrees-box -->
              </div><!-- .declination-degrees -->

              <div class="option-btns-contain">
                <label>
                  <input type="radio" name="declinationOptions" value="decimal" v-model="declinationOptions" checked>
                  <span>Decimal Deg</span>
                </label>
                <label>
                  <input type="radio" name="declinationOptions" value="degrees" v-model="declinationOptions">
                  <span>Deg/Min/Sec</span>
                </label>
              </div><!-- .option-btns-contain -->
            </div><!-- .input-wrap -->

        </div>

        <div class="fieldset">
          <h2 class="legend">Orbital Information</h2>

            <div class="input-wrap">
              <label for="orbital_p">Orbital Period</label>
              <input type="number" id="orbital_p" v-model="orbital_p" name="orbital_p" placeholder="400.00" step="0.0001" min="0" :readonly="!watchers_on && !tryme"> Yrs
            </div><!-- .input-wrap -->
            <div class="input-wrap">
              <label for="orbital_s">Orbital Separation</label>
              <input type="number" id="orbital_s" v-model="orbital_s" name="orbital_s" placeholder="10.00" step="0.0001" min="0" :readonly="!watchers_on && !tryme"> pc
          </div><!-- .input-wrap -->

          <div class="input-wrap">
            <label for="orbital_i">Orbital Inclination</label>
            <input type="number" id="orbital_i" v-model="orbital_i" name="orbital_i" placeholder="0.00" step="0.01" min="0">
          </div><!-- .input-wrap -->

            <div class="input-wrap">
              <label for="orbital_e">Orbital Eccentricity</label>
              <input type="number" id="orbital_e" v-model="orbital_e" name="orbital_e" placeholder="0.000" step="0.001" min="0">
            </div><!-- .input-wrap -->

        </div>


        <div class="submit-wrap"><button class="button" id="submit" v-on:click="doCalc"><span><strong>Calculate</strong> Gravitational Wave Strain</span></button></div>
      </div>

      <div class="calculating" v-else-if="calculated == 'calculating'" key="calcB">
        <div class="calc-anim"><div></div><div></div><span>Calculating...</span></div>
      </div>

      <div class="results" v-else-if="calculated && calculated != 'calculating'" key="calcC">

        <div v-show="result_rs == '?'">
          <p>Sorry, there was a problem calculating those values. Try again?</p>
          <div class="submit-wrap two">
            <button class="button" id="restart" v-on:click="calculated = false"><span>Go Back</span></button>
          </div>
          <p>Debug:</p>
          <textarea style="width:100%;height:500px;" v-model="error"></textarea>
        </div>

        <div v-show="result_rs != '?'">

          <p v-show="result_txt != ''"><strong> {{ result_txt }} </strong></p>

          <p v-if="result_png">
            <img :src="'https://gravcalc.org/output_maps/' + result_png + '.svg'" alt="output map">
          </p>

          <table class="result-table" cellspacing="0" cellpadding="0" border="0">
            <tbody>
              <tr>
                <th scope="row">Strain</th>
                <td><span v-html="result_strain"></span></td>
              </tr>
              <tr>
                <th scope="row">Residual&nbsp;Signature</th>
                <td><span v-html="result_rs"></span> &#956;s</td>
              </tr>
              <tr v-show="result_ds != '?'">
                <th scope="row">Confidence</th>
                <td><span>{{result_ds}}</span> %</td>
              </tr>
              <tr class="nobg" v-show="result_ds != '?'">
                <td></td>
                <td><p class="footnote">% confidence that there are no sources at this strain in the current NANOGrav data set</p></td>
              </tr>
            </tbody>
          </table>

          <p>In a typical pulsar, the residual effect produced by the black hole binary you've entered is <span v-html="result_rs"></span> microseconds.</p>
          <p>The current PTA can detect deviations around 100ns, and in the future we expect to reach 10ns. If your number is very far below these, it is unlikely to be detectable by Pulsar Timing Array in the near future.</p>

          <p v-show="result_png">The map shown above is the closest in strain and frequency to the source you've input. The percentage shown is found by interpolating between similar maps to estimate the confidence with which the current NANOGrav data set can rule out the source. All maps were generated based on the current NANOGrav data using analysis provided by Sarah Vigeland and Joe Simon. <router-link to="/pulsarmaps">Click here to view examples of the sensitivity maps we used.</router-link> For more information on how they were created, please see <a href="https://arxiv.org/pdf/1812.11585.pdf" target="_blank"> https://arxiv.org/pdf/1812.11585.pdf</a></p>

          <div class="submit-wrap two quad">
            <router-link to="/" class="button" id="restart"><span v-on:click="startNewCalc">Start New Calculation</span></router-link>
            <router-link to="/citations" class="blue button"><span>Cite This Page</span></router-link>
            <button class="button blue" id="restart" v-on:click="calculated = false"><span>Go Back</span></button>
            <router-link to="/game" class="blue button"><span>Play Game</span></router-link>
          </div>
        </div>
      </div>
    </transition>

  </div>
</template>

<script>
import _ from 'lodash';
import axios from 'axios';

export default {
  name: 'home',
  props: {
    doo: String
  },
  data: function() {
    return {
      m1: '',
      m2: '',
      m_ratio: Number,
      total_m: '',
      distance: Number,
      redshift: Number,
      position_ra: Number,
      position_dec: Number,
      ra_hrs: Number,
      ra_min: Number,
      ra_sec: Number,
      dec_deg: Number,
      dec_min: Number,
      dec_sec: Number,
      orbital_p: Number,
      orbital_s: Number,
      orbital_i: Number,
      orbital_e: Number,
      calculated: false,
      watchers_on: true,
      tryme: false,
      result_ds: '',
      result_rs: '',
      result_png: '',
      result_txt: '',
      result_strain: '',
      error: false,
      t: false,
      declinationOptions: 'decimal',
      raOptions: 'decimal'
    }
  },
  methods:{
    updateM1: _.debounce(function(newVal,force){
      if(isNaN(newVal.replace('e',''))) {
        this.m1 = newVal.replace(/[^0-9\-.e]/g,'');
        return;
      } else if(!force && (newVal.endsWith('e') || !newVal.includes('e'))) {
        return;
      } else {
        let m1 = Number(newVal);
        let m2 = Number(this.m2);
        let num = m2 + m1;
        this.m1 = m1.toExponential().replace('+','');
        this.total_m = num.toExponential().replace('+','');
        this.setRatio(m1,m2);
      }
    }, 1001),
    updateM2: _.debounce(function(newVal,force){
      if(isNaN(newVal.replace('e',''))) {
        this.m2 = newVal.replace(/[^0-9\-.e]/g,'');
        return;
      } else if(!force && (newVal.endsWith('e') || !newVal.includes('e'))) {
        return;
      } else {
        let m1 = Number(this.m1);
        let m2 = Number(newVal);
        let num = m1 + m2;
        this.m2 = m2.toExponential().replace('+','');
        this.total_m = num.toExponential().replace('+','');
        this.setRatio(m1,m2);
      }
    }, 1001),
    updateTM: _.debounce(function(newVal,force){
      if(isNaN(newVal)) {
        this.total_m = newVal.replace(/[^0-9\-.e]/g,'');
        return;
      } else if(!force && (newVal.endsWith('e') || !newVal.includes('e'))) {
        return;
      }  else {
        let total_m = Number(newVal);
        let m2 = Number(this.m2)
        let num = total_m - m2;
        this.total_m = total_m.toExponential().replace('+','');
        this.m1 = num.toExponential().replace('+','');
        let m1 = this.m1;
        this.setRatio(m1,m2);
      }
    }, 1001),
    updateR: _.debounce(function(newVal,force){
      if(isNaN(newVal)) {
        this.m_ratio = newVal.replace(/[^0-9\-.e]/g,'');
        return;
      } else if(!force && (newVal.endsWith('e') || !newVal.includes('e'))) {
        return;
      } else if (newVal == this.m_ratio) {
        return;
      }  else {
        this.m_ratio = newVal;
        let m1 = Number(this.m1);
        let m2 = Number(this.m2);
        if(m1 >= m2){
          this.m2 = (m1 * newVal).toExponential().replace('+','');
        }else{
          this.m1 = (m2 * newVal).toExponential().replace('+','');
        }
        this.total_m = (Number(this.m1)+Number(this.m2)).toExponential().replace('+','');
      }
    }, 1001),
    setRatio: function(m1,m2){
      var bigger, smaller;
      if(m1 >= m2){
        bigger = m1;
        smaller = m2;
      }else{
        bigger = m2;
        smaller = m1;
      }
      this.m_ratio = (smaller/bigger).toFixed(4);
    },
    getDistance: function() {
      clearTimeout(this.t);
      if(this.redshift == 0) { this.redshift = 1; }
      var vars = 'action=distancecalc&redshift='+this.redshift;
      axios.get( 'https://gravcalc.org/cgi-bin/calculate.py?'+vars )
        .then((response) => {
          this.distance = response.data.distance;
          this.t = setTimeout(() => { this.watchers_on = true; }, 1101);
        })
        .catch((error) => {
          console.log(error);
          this.watchers_on = true;
        });
    },
    getRedshift: function() {
      clearTimeout(this.t);
      if(this.distance == 0) { this.distance = 1; }
      this.distance = parseFloat(this.distance);
      var vars = 'action=redshiftcalc&distance='+this.distance;
      axios.get( 'https://gravcalc.org/cgi-bin/calculate.py?'+vars )
        .then((response) => {
          this.redshift = response.data.redshift;
          this.t = setTimeout(() => { this.watchers_on = true; }, 1101);
        })
        .catch((error) => {
          console.log(error);
          this.watchers_on = true;
        });
    },
    getOrbPer: function() {
      clearTimeout(this.t);
      if(this.orbital_s == 0) { this.orbital_s = 1; }
      var vars = 'action=orbitalpercalc&orbital_s='+this.orbital_s+'&total_m='+this.total_m;
      axios.get( 'https://gravcalc.org/cgi-bin/calculate.py?'+vars )
        .then((response) => {
          if(response.data.hasOwnProperty('orbital_p')) {
            this.orbital_p = response.data.orbital_p.toPrecision(4);
            this.t = setTimeout(() => { this.watchers_on = true; }, 1101);
          } else {
            this.watchers_on = true;
          }
        })
        .catch((error) => {
          console.log(error);
          this.watchers_on = true;
        });
    },
    getOrbSep: function() {
      clearTimeout(this.t);
      if(this.orbital_p == 0) { this.orbital_p = 1; }
      var vars = 'action=orbitalsepcalc&orbital_p='+this.orbital_p+'&total_m='+this.total_m;
      axios.get( 'https://gravcalc.org/cgi-bin/calculate.py?'+vars )
        .then((response) => {
          if(response.data.hasOwnProperty('orbital_s')) {
            this.orbital_s = response.data.orbital_s.toPrecision(4);
            this.t = setTimeout(() => { this.watchers_on = true; }, 1101);
          } else {
            this.watchers_on = true;
          }
        })
        .catch((error) => {
          console.log(error);
          this.watchers_on = true;
        });
    },
    doCalc: function() {
      this.result_strain = '';
      this.result_ds = '';
      this.result_rs = '';
      this.result_png = '';
      this.result_txt = '';
      this.error = false;   
      this.calculated = 'calculating';
      this.scrollToTop(400);

      var m1, m2, distance, redshift, total_m, m_ratio, position_ra, position_dec, ra_hrs, ra_min, ra_sec, dec_deg, dec_min, dec_sec, orbital_p, orbital_s, orbital_i, orbital_e;

      if(this.m1 == '') { m1 = '1e9'; }
      else { m1 = this.m1; }

      if(this.m2 == '') { m2 = '1e9'; }
      else { m2 = this.m2; }

      if(this.distance == '' || this.distance === Number) { distance = 100; }
      else { distance = this.distance; }

      if(this.redshift == '' || this.redshift === Number) { redshift = 0.0237; }
      else { redshift = this.redshift; }

      if(this.total_m == '') { total_m = '2e9'; }
      else { total_m = this.total_m; }

      if(this.m_ratio == '' || this.m_ratio === Number) { m_ratio = 1.00; }
      else { m_ratio = this.m_ratio; }

      if(this.position_ra == '' || this.position_ra === Number) { position_ra = 20.24444444; }
      else { position_ra = this.position_ra; }

      if(this.ra_hrs == '' || this.ra_hrs === Number) { ra_hrs = 20; } else { ra_hrs = this.ra_hrs; }
      if(this.ra_min == '' || this.ra_min === Number) { ra_min = 14; } else { ra_min = this.ra_hrs; }
      if(this.ra_sec == '' || this.ra_sec === Number) { ra_sec = 40; } else { ra_sec = this.ra_hrs; }

      if(this.position_dec == '' || this.position_dec === Number) { position_dec = 80; }
      else { position_dec = this.position_dec; }

      if(this.dec_deg == '' || this.dec_deg === Number) { dec_deg = 80; } else { dec_deg = this.dec_deg; }
      if(this.dec_min == '' || this.dec_min === Number) { dec_min = 0; } else { dec_min = this.dec_min; }
      if(this.dec_sec == '' || this.dec_sec === Number) { dec_sec = 0; } else { dec_sec = this.dec_sec; }

      if(this.orbital_p == '' || this.orbital_p === Number) { orbital_p = 400.0; }
      else { orbital_p = this.orbital_p; }

      if(this.orbital_s == '' || this.orbital_s === Number) { orbital_s = 10.00; }
      else { orbital_s = this.orbital_s; }

      if(this.orbital_i == '' || this.orbital_i === Number) { orbital_i = 0.000; }
      else { orbital_i = this.orbital_i; }

      if(this.orbital_e == '' || this.orbital_e === Number) { orbital_e = 0.000; }
      else { orbital_e = this.orbital_e; }

      var vars = 'action=calculate' +
        '&m1=' + m1 + '&m2=' + m2 + '&distance=' + distance +
        '&redshift=' + redshift + '&total_m=' + total_m +
        '&m_ratio=' + m_ratio + '&orbital_p=' + orbital_p +
        '&orbital_s=' + orbital_s + '&orbital_i=' + orbital_i +
        '&orbital_e=' + orbital_e + '&position_ra=' + position_ra +
        '&ra_hrs=' + ra_hrs + '&ra_min=' + ra_min + '&ra_sec=' + ra_sec +
        '&position_dec=' + position_dec + '&dec_deg=' + dec_deg + 
        '&dec_min=' + dec_min + '&dec_sec=' + dec_sec +
        '&ra_opt=' + this.raOptions + '&dec_opt=' + this.declinationOptions;

      axios.get( 'https://gravcalc.org/cgi-bin/calculate.py?'+vars )
        .then((response) => {
          if(response.data.result_ds) {
            this.result_ds = Number(response.data.result_ds).toPrecision(4);
          } else {
            this.result_ds = '?';
          }
          if(response.data.result_rs) {
            if(String(response.data.result_rs).includes('e')) {
              this.result_rs = Number(response.data.result_rs).toPrecision(4).replace('e',' &times; 10<sup>') + '</sup>';
            } else {
              this.result_rs = Number(response.data.result_rs).toPrecision(4);
            }
          } else {
            this.result_rs = '?';
          }

          if(response.data.error_text) {
            this.result_txt = response.data.error_text;
          }
          if(response.data.PNG_name) {
            this.result_png = response.data.PNG_name;
          }
          if(response.data.result_strain) {
            if(String(response.data.result_strain).includes('e')) {
              this.result_strain = Number(response.data.result_strain).toPrecision(4).replace('e',' &times; 10<sup>') + '</sup>';
            } else {
              this.result_strain = Number(response.data.result_strain).toPrecision(4);
            }            
          }
          
          this.error = response.data;
          setTimeout(() => { this.calculated = true; }, 1000); //wait a sec
        })
        .catch(function (error) {
          console.log(error);
          this.calculated = true;
        });
    },
    setCalculatorValues: function(val) {
      this.watchers_on = false;
      this.tryme = true;
      clearTimeout(this.t);
      this.t = setTimeout(() => {
        if(val == '3c66b') {
          this.m1 = '0.65e10';
          this.m2 = '0.65e10';
          this.m_ratio = '1.0000';
          this.total_m = '1.3e10';
          this.distance = 80.00;
          this.redshift = 0.0215;
          this.position_ra = 2.3775;
          this.position_dec = 43.0355;
          this.ra_hrs = 2;
          this.ra_min = 22;
          this.ra_sec = 39.612;
          this.dec_deg = 43;
          this.dec_min = 2;
          this.dec_sec = 7.80;
          this.orbital_p = 1.05;
          this.orbital_s = 0.02;
          this.orbital_i = 0.00;
          this.orbital_e = 0.001;
        }
        else if(val == 'm87') {
          this.m1 = '6.6e9';
          this.m2 = '6.6e9';
          this.m_ratio = '1.0000';
          this.total_m = '1.32e10';
          this.distance = 16.40;
          this.redshift = 0.0038;
          this.position_ra = 12.5136111;
          this.position_dec = 12.39111111;
          this.ra_hrs = 12;
          this.ra_min = 30;
          this.ra_sec = 49.00;
          this.dec_deg = 12;
          this.dec_min = 23;
          this.dec_sec = 28;
          this.orbital_p = 1499;
          this.orbital_s = 3.00;
          this.orbital_i = 0.00;
          this.orbital_e = 0.80;
        }
        else {
          this.m1 = '';
          this.m2 = '';
          this.m_ratio = Number;
          this.total_m = '';
          this.distance = Number;
          this.redshift = Number;
          this.position_ra = Number; 
          this.position_dec = Number; 
          this.ra_hrs = Number; 
          this.ra_min = Number;
          this.ra_sec = Number; 
          this.dec_deg = Number; 
          this.dec_min = Number; 
          this.dec_sec = Number; 
          this.orbital_p = Number;
          this.orbital_s = Number;
          this.orbital_i = Number;
          this.orbital_e = Number;
        }
        this.t = setTimeout(() => { this.watchers_on = true; this.tryme = false; }, 1101);
      }, 50);
    },
    startNewCalc: function() {
      this.setCalculatorValues();
      this.calculated = false;
      this.result_ds = '';
      this.result_rs = '';
      this.result_txt = '';
      this.result_png = '';
      this.scrollToTop(300);
    },
    scrollToTop: function(duration) {
      var scrollStep = -window.scrollY / (duration / 15),
          scrollInterval = setInterval(function(){
          if ( window.scrollY != 0 ) {
              window.scrollBy( 0, scrollStep );
          }
          else clearInterval(scrollInterval);
      },15);
    }
  },
  mounted: function() {
    this.setCalculatorValues(this.doo);
  },
  computed: {
    calculatorTitle: function() {
      let val = this.doo;
      if(val == '3c66b') {
        return '3C 66B - as postulated by <a href="http://science.sciencemag.org/content/300/5623/1263.full" target="_blank">Sudou et al (2003)</a>';
      }
      else if(val == 'm87') {
        return 'M87 - as postulated by <a href="https://academic.oup.com/pasj/article/68/6/106/2433931" target="_blank">Yonemaru et al (2016)</a>';
      }
      else {
        return '<span class="mobile-only">Or</span> Enter Your Parameters Below';
      }
    }
  },
  watch: {
    doo: function(val) {
      this.calculated = false;
      this.setCalculatorValues(val);
    },
    redshift: {
      handler: _.debounce(function(val) {
        if(this.watchers_on && val != '') { this.watchers_on = false; this.getDistance(); }
      }, 1001)
    },
    distance: {
      handler: _.debounce(function(val) {
        if(this.watchers_on && val != '') { this.watchers_on = false; this.getRedshift(); }
      }, 1001)
    },
    orbital_p: {
      handler: _.debounce(function(val) {
        if(this.watchers_on && val != '') { this.watchers_on = false; this.getOrbSep(); }
      }, 1001)
    },
    orbital_s: {
      handler: _.debounce(function(val) {
        if(this.watchers_on && val != '') { this.watchers_on = false; this.getOrbPer(); }
      }, 1001)
    },
    declinationOptions: function(){
      var dec;
      if(this.declinationOptions == "decimal"){
        var deg = parseFloat(this.dec_deg);
        var min = parseFloat(this.dec_min);
        var sec = parseFloat(this.dec_sec);

        dec = deg+min/60+sec/3600;
        this.position_dec = dec.toFixed(8);
      }else{
        dec = this.position_dec;

        this.dec_deg = parseInt(dec);
        this.dec_min = parseInt((dec - this.dec_deg)*60);
        this.dec_sec = parseFloat((dec - this.dec_deg - this.dec_min/60)*3600).toFixed(4);
      }
    },
    raOptions: function(){
      var dec;
      if(this.raOptions == "decimal"){

        var hrs = parseFloat(this.ra_hrs);
        var min = parseFloat(this.ra_min);
        var sec = parseFloat(this.ra_sec);

        dec = hrs+min*1/60+sec*1/3600;
        this.position_ra = dec.toFixed(8);
      }else{
        dec = this.position_ra;

        this.ra_hrs = parseInt(dec);
        this.ra_min = parseInt((dec - this.ra_hrs)*60);
        this.ra_sec = parseFloat((dec - this.ra_hrs - this.ra_min/60)*3600).toFixed(4);
      }
    }
  }
}
</script>

<style lang="scss">
$blue: #27AAE1;
$gold: #FCBB07;
$orange: #F7941E;
$paleGold: #FCDB7E;
$grey: #222222;
$break: 678px;

h1{
  font-size: 1.5em;
  a { white-space: nowrap; }
}

input, input:read-only { 
  background: #fff; 
  color: #000; 
  border: solid 1px #000; 
  background-position: center center;
}
input:read-only { 
  transition: all 0.2s ease; 
  opacity: 0.5;
  background: #fff url(data:image/gif;base64,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) no-repeat center center / auto 80%;

}

::placeholder {
  color: #888888;
  opacity: 0.5;
}

.calculator {
  text-align: left;
  label {
    text-transform: uppercase;
    display: block;
  }
  .fieldset { margin-bottom: 10px; }
  .legend {
    color: #fd7;
    font-weight: bold;
    text-transform: uppercase;
  }
}

#view .result-table {
  width: 100%;
  th, td { 
    padding: 5px; 
    width: 50%; 
    background: #000; 
    border-bottom: solid 3px $grey;
    vertical-align: middle; 
  }
  .nobg { td, th { background: none; } } 
  th { padding: 10px 5px; }
  span { font-size: 1.5em; }
  p { 
    margin: 0; 
    font-size: 0.8em;
    color: #fff;
  }
}

.mod-btns{
  display: flex;
  flex-direction: row;
  width: 100%;
  background: $grey;
  flex-wrap: wrap;
  margin: 15px 0;
  @media (min-width: $break){
    .mobile-only{
      display: none;
    }
  }

  h1{
    flex: 1 1 100%;

    @media(min-width: $break){
      display: none;
    }
  }

  #submitTop{
    flex: 1 1 100%;
    order: 4;
    background: none;
    margin: 5px;
    span{
      background: $orange;
      color: #fff;
    }

    @media(min-width: $break){
      flex: 1 1 70%;
      order: 0;

      &:hover{
        span{
          background: $gold;
          color: #000;
        }
      }
    }
  }


  a, button{
    display: flex;
    align-items: center;
    font-weight: bold;
    color: #fff;
    text-decoration: none;
    border: solid 1px #fff;
    width: 100%;
    padding: 3px;
    margin: 5px 5px;
    flex: 1 1 30%;

    @media(min-width: $break){
      flex: 1 1 20%;
    }





    span{
      color: #000;
      background: #fff;
      width: 100%;
      display: flex;
      align-items: center;
      font-size: 16px;
      padding: 10px;
      transition: all 0.25s;
      text-align: center;
      height: 100%;
      justify-content: center;




      &.gold{
        background: $gold;
        color: #000;
      }

      @media (min-width: $break){
        &:hover{
          background: $blue;
          color: #fff;
          &.gold {
            background: $orange;
            color: #fff;
          }
        }
      }

    }
  }
}

#view .fieldsets {
  display: flex;
  flex-wrap: wrap;
  align-items: flex-start;
  .fieldset {
    flex: 1 1 250px;
    .legend { border-bottom: none; margin: 0; }
  }
}

.calc-anim {
  display: flex;
  align-items: center;
  justify-content: space-around;
  position: relative;
  width: 80%;
  margin: 0 auto;
  span {
    color: #fff;
    font-size: 1.5em;
    display: block;
    text-align: center;
    padding: 47% 0 53%;
    height: 1px;
    animation: shrink 4s ease-out 1;
  }
}
.calc-anim div {
  position: absolute;
  border: 2px solid #fff;
  opacity: 0;
  width: 100%;
  height: 100%;
  border-radius: 50%;
  background: radial-gradient(circle at 50%, #000 0%, transparent 10%, transparent 50%, #fff 99%);
  animation: ripple 1.5s ease-out infinite;
}
.calc-anim div:nth-child(2) {
  animation-delay: 0.5s;
}
.calc-anim { div, span { animation-fill-mode: forwards; } }
@keyframes ripple {
  0% {
    transform: scale(0);
    opacity: 1;
  }
  100% {
    transform: scale(1);
    opacity: 0;
  }
}
@keyframes shrink {
  0% { transform: scale(1) rotate(0deg); }
  100% { transform: scale(0) rotate(-15deg); }
}
.fade-enter-active, .fade-leave-active {
  transition: opacity .2s;
}
.fade-enter, .fade-leave-to {
  opacity: 0;
}

.full-width.center{
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 10px;
}

.option-btns-contain{
  display: flex;
  width: 190px;
  margin: 10px 0;
  // overflow: hidden;
  border: solid $blue 2px;
  border-radius: 5px;
  overflow: hidden;

  label{
    width: 50%;
    position: relative;
    cursor: pointer;
  }

  span{
    display: block;
    background: none;
    padding: 5px;
    box-sizing: border-box;
    cursor: pointer;
    font-size: 0.8em;
    text-align: center;
    transition: all 0.25s;
  }

  input{
    display: none;

    &:checked + span{
      color: #000;
      background: $blue;
    }
  }
}

#position_ra, #position_dec { line-height: 22px; }

#view .thirds{
  display: flex;
  flex-wrap: nowrap;

  .third-box{
    flex: 1 1 30%;
    padding-right: 5px;
    white-space: nowrap;

    &:last-of-type {
      flex: 1 1 40%;
    }

    input{
      width: calc(100% - 20px);
      margin-right: 3px;
      padding: 10px 1px;
      font-size: 0.95em;
      line-height: 22px;
      @media (min-width:$break) { padding: 5px 1px; }
    }

  }
}
</style>
